export const leakTypeSwitch = (type) => {
  switch (type) {
    case "A":
      return {
        ko: "유지",
        en: "Maintain",
        es: "Mantener"
      }

    case "B":
      return {
        ko: "증가",
        en: "Increase",
        es: "Aumento"
      }

    case "C":
      return {
        ko: "감소",
        en: "Decrease",
        es: "Disminución"
      }

    case "D":
      return {
        ko: "기타",
        en: "Other",
        es: "Otro"
      }

    default:
      return {
        ko: "-",
        en: "-",
        es: "-"
      }
  }
}
